module.exports = __webpack_public_path__ + "static/img/127_TO8_1677_og.fae2ce2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/127_TO8_1677_og.jpg
// module id = fJUE
// module chunks = 0